import { type UnitOfMeasure, getUnitLabel } from '@/lib/units/unit-conversion'
import type { GuideUnit } from '../types/guide-unit'

export function guideUnitToUnitOfMeasure(unit: GuideUnit): UnitOfMeasure | null {
  if (unit === 'pica') return 'Picas'
  if (unit === 'point') return 'Points'
  if (unit === 'inch') return 'Inches'

  return null
}

/** Suffix shown inside the gutter inputs: none for picas, the unit label otherwise, `mm` for mm. */
export function resolveGutterUnitLabel(unit: GuideUnit): string | null {
  const targetUnit = guideUnitToUnitOfMeasure(unit)

  if (targetUnit != null && targetUnit !== 'Picas') return getUnitLabel(targetUnit)
  if (unit === 'mm') return 'mm'

  return null
}
